export default function (state, getters, rootState, rootGetters) {
    return state.page * getters.settings.col - 1;
}